module.exports = __webpack_public_path__ + "0eccd383214a5b3e29e5e888d310e0c5.svg";